import { api } from '@/api/client';
import { useQuery } from '@tanstack/react-query';
import type { WorkflowExecution } from '../types';

interface UseExecutionsOptions {
  enabled?: boolean | undefined;
  refetchInterval?: number | undefined;
}

export function useExecutions(options?: UseExecutionsOptions | undefined) {
  const interval = options?.refetchInterval ?? 30_000;
  const { data, isLoading, error, refetch } = useQuery<WorkflowExecution[], Error>({
    queryKey: ['workflows', 'executions'],
    queryFn: async () => {
      const res = await api.get<{ data: WorkflowExecution[] }>('/workflows/executions');
      return res.data;
    },
    refetchInterval: interval,
    staleTime: Math.min(interval - 5_000, 25_000),
    enabled: options?.enabled ?? true,
  });

  return { executions: data ?? [], isLoading, error, refetch };
}
